/** Extensions accepted by Kuber.MerchantDashboard.API ImageController. */
const VALID_UPLOAD_EXTENSIONS = new Set([".jpg", ".jpeg", ".png"]);

/**
 * Ensure a File is valid for POST /api/image (backend reads extension from FileName).
 */
export function ensureValidImageFile(file, baseName = "image") {
  if (!file) {
    throw new Error("No image file to upload");
  }

  const size = file.size ?? 0;
  if (size <= 0) {
    throw new Error("Image file is empty - try cropping again or use another image");
  }

  const safeBase =
    String(baseName || file.name || "image")
      .replace(/\.[^.]+$/, "")
      .replace(/[^\w.-]+/g, "-")
      .trim() || "image";

  const currentName = file.name || "";
  const currentExt = currentName.includes(".")
    ? `.${currentName.split(".").pop().toLowerCase()}`
    : "";

  let ext = VALID_UPLOAD_EXTENSIONS.has(currentExt) ? currentExt : ".jpg";
  // Studio output is always JPEG; keep .png only when source was PNG and name is valid.
  if (ext === ".png" && file.type && file.type !== "image/png") {
    ext = ".jpg";
  }

  const targetName = `${safeBase}${ext}`;
  const targetType =
    ext === ".png" ? "image/png" : ext === ".jpeg" || ext === ".jpg" ? "image/jpeg" : file.type || "image/jpeg";

  if (
    file instanceof File &&
    file.name === targetName &&
    file.type === targetType &&
    file.size > 0
  ) {
    return file;
  }

  return new File([file], targetName, {
    type: targetType,
    lastModified: Date.now(),
  });
}
